import { useEffect, useMemo, useState } from 'react'
import LottieReact from 'lottie-react'
import {
  cloneLottieData,
  resolveLottieControlExpressions,
} from '../utils/resolveLottieControlExpressions'

export default function Lottie({ animationData, path, ...rest }) {
  const [fetched, setFetched] = useState(null)

  useEffect(() => {
    if (!path) {
      setFetched(null)
      return undefined
    }
    let cancelled = false
    fetch(path)
      .then((response) => {
        if (!response.ok) throw new Error('Animation introuvable')
        return response.json()
      })
      .then((data) => {
        if (!cancelled) setFetched(resolveLottieControlExpressions(data))
      })
      .catch(() => {
        if (!cancelled) setFetched(null)
      })
    return () => {
      cancelled = true
    }
  }, [path])

  const resolved = useMemo(() => {
    if (path) return fetched
    if (!animationData) return null
    return resolveLottieControlExpressions(cloneLottieData(animationData))
  }, [animationData, fetched, path])

  if (!resolved) return null
  return <LottieReact animationData={resolved} {...rest} />
}
